<template>
    <v-layout v-if="ready" justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="shop-support-view">
            <div v-if="!$route.query._support" class="headline text-start mt-8">게시글 등록</div>
            <div v-else class="headline text-start mt-8">게시글 상세</div>

            <v-card class="mt-4">
                <v-card-title class="subtitle-1 pb-0">제목</v-card-title>
                <v-card-text>
                    <v-row class="mt-3">
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="support.subject" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-4">
                <v-card-title class="subtitle-1">썸네일</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="auto" class="py-0">
                            <v-img v-if="support.thumb" max-width="96" max-height="96" :src="createObjectURL(support.thumb)" contain></v-img>
                            <v-responsive v-else width="96" height="96" class="grey lighten-2">
                                <v-row align="center" class="fill-height" justify="center"><v-icon color="black">mdi-pencil</v-icon></v-row>
                            </v-responsive>
                        </v-col>
                        <v-col class="py-0">
                            <v-file-input v-model="support.thumb" label="썸네일 이미지" persistent-placeholder class="mt-2 mx-3" show-size accept="image/*"></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-4">
                <v-card-title class="subtitle-1">아동 기본정보</v-card-title>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-card-subtitle>이미지(793*793)</v-card-subtitle>
                        <v-divider />
                        <v-responsive :aspect-ratio="1 / 1">
                            <v-card-text>
                                <v-tabs-items v-if="imgSrcs.length" :value="image_selected">
                                    <v-tab-item v-for="src in imgSrcs" :key="src">
                                        <v-responsive :aspect-ratio="1 / 1">
                                            <work-imgs-overlay :files="imgSrcs.map((url) => ({ url }))" disableLink>
                                                <template #activator="{ attrs, on, setIndex }">
                                                    <v-img :src="src" width="100%" :aspect-ratio="1 / 1" style="cursor: pointer" v-bind="attrs" v-on="on" @click="setIndex({ url: src })" />
                                                </template>
                                            </work-imgs-overlay>
                                        </v-responsive>
                                    </v-tab-item>
                                </v-tabs-items>
                                <v-img v-else :aspect-ratio="1 / 1">
                                    <v-overlay absolute z-index="0" color="grey darken-1">이미지가 없습니다</v-overlay>
                                </v-img>
                            </v-card-text>
                        </v-responsive>
                        <v-divider />
                        <v-card-actions>
                            <images-input v-model="support.files" @mouseover="setImage_selected" />
                        </v-card-actions>
                    </v-col>
                    <v-col>
                        <v-card-text class="pb-6">
                            <v-row class="mt-4">
                                <v-col cols="4" class="py-0">
                                    <v-card-subtitle>* 이름 :</v-card-subtitle> 
                                </v-col>
                                <v-col cols="8" class="py-0">
                                    <v-text-field v-model="support.child.name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="4" class="py-0">
                                    <v-card-subtitle>* 성별 :</v-card-subtitle> 
                                </v-col>
                                <v-col cols="8" class="py-0">
                                    <v-text-field v-model="support.child.sex"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="4" class="py-0">
                                    <v-card-subtitle>* 생년월일 :</v-card-subtitle> 
                                </v-col>
                                <v-col cols="8" class="py-0">
                                    <v-text-field v-model="support.child.birthDay"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="4" class="py-0">
                                    <v-card-subtitle>* 가족사항 :</v-card-subtitle> 
                                </v-col>
                                <v-col cols="8" class="py-0">
                                    <v-text-field v-model="support.child.family"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="4" class="py-0">
                                    <v-card-subtitle>* 건강상태 :</v-card-subtitle> 
                                </v-col>
                                <v-col cols="8" class="py-0">
                                    <v-text-field v-model="support.child.health"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="mt-4">
                <v-card-title class="subtitle-1">상세내용</v-card-title>
                <v-card-text>
                    <naver-smarteditor v-model="support.content"></naver-smarteditor>
                </v-card-text>
            </v-card>

            <v-row justify="center">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>

        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import ImagesInput from "@/components/console/dumb/images-input.vue";
import WorkImgsOverlay from "@/components/console/auction/work-imgs-overlay.vue";

import draggable from "vuedraggable";

import { mdiTagPlus } from "@mdi/js";

export default {
    components: {
        VDatetimeField,
        NaverSmarteditor,
        ImagesInput,
        draggable,
        WorkImgsOverlay
    },
    data() {
        return {
            mdiTagPlus,
            ready: false,

            ///////////////////////////////////////////////
            // 게시글 정보
            ///////////////////////////////////////////////
            support: {
                code: this.$route.query.code,

                subject: undefined,
                content: undefined,

                thumb: undefined,
                files: [],

                child: {
                    name: null,
                    sex: null,
                    birthDay: null,
                    family: null,
                    health: null,
                }
            },

            image_selected: null

        };
    },
    mounted() {
        this.init();
    },
    computed:{
        imgSrcs() {
            if(this.support.files == undefined) this.support.files = []
            return this.support.files.map((file) => URL.createObjectURL(file));
        },
    },
    methods: {
        async init() {
            console.log(this.$route.params);
            try {
                if (this.$route.params._support !== undefined) {
                    let { support} = await api.console.supports.get({ _id: this.$route.params._support });
                    support.files = await Promise.all((support.files || []).map(async ({ url }) => await api.getResource(url, true)));
                    if (support.thumb) support.thumb = await api.getResource(support.thumb, true);
                    this.support = support;
                }

                // if (!!this.$route.params._support) {
                //     var { summary } = await api.console.supports.gets({
                //         headers: { skip: 0, limit: 1 },
                //         params: {
                //             code: this.$route.query.code,
                //         },
                //     });
                //     this.support.sequence = summary.totalCount + 1;
                // }

                this.ready = true;
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        async save() {
            try {
                let { _files = [], files = [], thumb, ...support } = this.support;
                ////////////////////////////////////////////////////////////////
                // 0. 리소스 삭제
                ////////////////////////////////////////////////////////////////
                if (_files.length > 0) await Promise.all(_files.map(async (_id) => await api.console.supports.files.delete({ _support: support?._id, _id })));

                ////////////////////////////////////////////////////////////////
                // 1. 게시글 저장
                ////////////////////////////////////////////////////////////////
                [{ support }] = [support._id ? await api.console.supports.put(support) : await api.console.supports.post(support)];

                ////////////////////////////////////////////////////////////////
                // 2. 리소스 저장
                ////////////////////////////////////////////////////////////////
                if (thumb) await api.console.supports.postThumb(support, thumb);
                if (files.length > 0) await Promise.all(files.map(async (file, index) => await api.console.supports.files.post({ _support: support?._id, index }, file)));

                alert(this.support._id ? "수정되었습니다" : "저장되었습니다");

                this.$router.go(-1);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        setImage_selected(file) {
            const index = this.support.files.findIndex((img) => img == file);
            this.image_selected = index;
        },
        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return;
            }
        },
    },
    watch: {
        "board.files.length"() {
            this.image_selected = this.support?.files?.length - 1;
        },
    },
};
</script>
